/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode';
import { Card, Typography, Box, CircularProgress, Button, Divider, Chip } from '@mui/material';
import { AccountBalanceWallet } from '@mui/icons-material';
import { styled } from '@mui/system';
import { handleCatchError } from 'utils/CatchHandler';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import {
    bcToWalletApi,
    createOrderApi,
    getWalletChargesApi,
    payIntentApi,
    statusCheckIntentApi
} from 'utils/API/Merchant APIs/WalletApiCalls';
import UpiPaymentQR from 'views/BalanceSection/customComponents/IntentQR';
import { Result } from 'antd';
import Spinner from '../LoadingSinner';

const StyledCard = styled(Card)(({ theme }) => ({
    maxWidth: 600,
    // margin: '20px auto',
    borderRadius: '16px',
    padding: '10px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxHeight: '80vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&:hover': {
        transform: 'translateY(-5px)'
    }
}));

const QrContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
    // margin: '20px 0'
});

const BcFee = ({ message, feeDetails, qrValue, plan_id, onOk }) => {
    const [qrImage, setQrImage] = useState('');
    const [payOrderModalOpen, setPayOrderModalOpen] = useState(false);
    const [txnStatus, setTxnStatus] = useState('PENDING');
    const [paymentCompleteModalOpen, setPaymentCompleteModalOpen] = useState(false);
    const [rrn, setRrn] = useState('');
    const [loading, setLoading] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (feeDetails) {
            getServiceCharge();
        }
    }, [feeDetails]);

    const getServiceCharge = async () => {
        const amount = feeDetails;
        try {
            const payload = { amount };
            const response = await getWalletChargesApi(payload);
            if (response?.data?.success) {
                createOrder();
            }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const createOrder = async () => {
        try {
            const payload = {
                bcplan: true,
                plan_id: plan_id,
                amount: feeDetails,
                customerEmail: localStorage.getItem('email_id'),
                customerPhone: localStorage.getItem('agentmobile')
            };
            const response = await createOrderApi(payload);

            if (response?.data?.success) {
                const orderId = response?.data?.result?.orderId;
                payOrder({ orderIdProp: orderId });
            } else {
                const message = response?.data?.message;
                // if (message) {
                //     globalNotifyError(message);
                // }
            }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const payOrder = async ({ orderIdProp }) => {
        const agentid = localStorage.getItem('id');
        try {
            const payloadIntent = { amount: feeDetails, orderId: orderIdProp, agent_id: agentid, bcconvertion: false };
            const response = await payIntentApi(payloadIntent);
            setQrImage(response?.data?.data);
            setPayOrderModalOpen(true);
            handleStatusCheckApiCalls(response?.data?.data?.orderId);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const orderStatus = async (orderIdProp) => {
        const type = 'wallet';
        try {
            const agent_id = localStorage.getItem('id');
            const payload = { orderId: orderIdProp, type, agent_id, bcplan: true, plan_id: plan_id };
            const response = await statusCheckIntentApi(payload);

            if (response?.status === 200) {
                if (response?.data?.data?.txnStatus != 'PENDING') {
                    const successMessage = response?.data?.message;
                    globalNotifySuccess(successMessage);
                    setTxnStatus(response?.data?.data?.txnStatus);
                    clearInterval(intervalRef.current);
                    setPayOrderModalOpen(false);
                    setPaymentCompleteModalOpen(true);
                    setRrn(response?.data?.data?.rrn);
                } else {
                    //pending logic
                    setTxnStatus(response?.data?.data?.txnStatus);
                    setRrn(response?.data?.data?.rrn);
                    // dispatch(fetchWalletBalanceAsync());
                }
            }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    const fetchWalletBalanceToBcConvertion = async () => {
        try {
            setLoading(true);
            const payload = { plan_id: plan_id, amount: feeDetails };
            const response = await bcToWalletApi(payload);
            if (response?.data?.success) {
                onOk();
                globalNotifySuccess(response?.data?.message);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    useEffect(() => {
        if (qrValue) {
            QRCode.toDataURL(qrValue, {
                width: 200,
                margin: 2,
                color: {
                    dark: '#333333',
                    light: '#ffffff'
                }
            })
                .then((url) => {
                    setQrImage({ url });
                })
                .catch((err) => {
                    console.error('Error generating QR code', err);
                });
        }
    }, [qrValue]);

    const handleStatusCheckApiCalls = (orderIdValue) => {
        orderStatus(orderIdValue);
        intervalRef.current = setInterval(() => {
            orderStatus(orderIdValue);
        }, 10000);
    };

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const handleGenerateNewQr = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        setTxnStatus('');
        setRrn('');
        setPaymentCompleteModalOpen(false);
        setQrImage('');
        setPayOrderModalOpen(false);

        createOrder();
    };

    const normalizedStatus = (txnStatus || '').toLowerCase();
    return (
        <StyledCard>
            {!paymentCompleteModalOpen ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3, mt: 2, width: '100%' }}>
                        <Button
                            variant="contained"
                            startIcon={<AccountBalanceWallet />}
                            onClick={fetchWalletBalanceToBcConvertion}
                            sx={{
                                borderRadius: '50px',
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '1rem',
                                px: 4,
                                py: 1.5,
                                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                                boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                                '&:hover': {
                                    background: 'linear-gradient(45deg, #1976D2 30%, #00BCD4 90%)',
                                    transform: 'scale(1.02)',
                                    transition: 'transform 0.2s',
                                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)'
                                }
                            }}
                        >
                            Convert BC with Wallet Balance
                        </Button>
                        <Typography variant="subtitle2" color="error" sx={{ mt: 1 }}>
                            It will deduct Rupees {feeDetails} from your wallet.
                        </Typography>
                        <Divider sx={{ width: '80%', mt: 3, mb: 1 }}>
                            <Chip label="OR" size="small" sx={{ color: 'text.secondary', fontWeight: 500 }} />
                        </Divider>
                    </Box>
                    <QrContainer>
                        {qrImage ? (
                            <UpiPaymentQR intentDetails={qrImage} handleCloseModal={() => setPayOrderModalOpen(false)} />
                        ) : (
                            <Box
                                sx={{
                                    height: 300,
                                    width: 300,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                    borderRadius: 4,
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                                    border: '1px solid rgba(0,0,0,0.05)',
                                    p: 3,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <CircularProgress
                                    size={48}
                                    thickness={4}
                                    sx={{
                                        color: (theme) => theme.palette.primary.main,
                                        mb: 3,
                                        filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))'
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 1,
                                        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent'
                                    }}
                                >
                                    Generating QR Code
                                </Typography>
                                <Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: '80%' }}>
                                    Please wait while we fetch your secure payment QR...
                                </Typography>
                            </Box>
                        )}
                    </QrContainer>

                    <Box textAlign="center" sx={{ mt: 2 }}>
                        <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic', display: 'block', mb: 1 }}>
                            Please verify the amount before paying.
                        </Typography>

                        {setTxnStatus == 'SUCCESS' && (
                            <Button variant="outlined" size="small" onClick={onOk}>
                                OK
                            </Button>
                        )}
                    </Box>
                </>
            ) : (
                <>
                    {txnStatus === 'EXPIRED' ? (
                        <Result
                            status="warning"
                            title="Payment Expired!"
                            subTitle="Your transaction has expired. Please generate a new QR and try again."
                            extra={[
                                <Button key="regenerate" variant="contained" color="primary" onClick={handleGenerateNewQr}>
                                    Generate New QR
                                </Button>
                            ]}
                        />
                    ) : (
                        <Result
                            status={
                                normalizedStatus === 'success'
                                    ? 'success'
                                    : ['fail', 'failed', 'failure', 'error', 'declined'].includes(normalizedStatus)
                                    ? 'error'
                                    : 'warning'
                            }
                            title={`Payment Status: ${txnStatus || 'Unknown'} !`}
                            subTitle={
                                normalizedStatus === 'success'
                                    ? `Transaction RRN for reference: ${rrn}`
                                    : ['fail', 'failed', 'failure', 'error'].includes(normalizedStatus)
                                    ? 'Your transaction has failed. Please try again.'
                                    : normalizedStatus === 'declined'
                                    ? 'Your transaction request has been declined. Please try again.'
                                    : 'Transaction is under processing. Please wait.'
                            }
                            extra={[
                                <Button key="close" variant="contained" color="primary" onClick={onOk}>
                                    Close
                                </Button>
                            ]}
                        />
                    )}
                </>
            )}
            <Spinner loading={loading} texts={['Processing your wallet conversion...', 'Please do not refresh or close the window.']} />
        </StyledCard>
    );
};

BcFee.propTypes = {
    message: PropTypes.string,
    feeDetails: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    qrValue: PropTypes.string.isRequired
};

BcFee.defaultProps = {
    message: 'Please pay the requisite fees to proceed.',
    feeDetails: 0,
    qrValue: ''
};

export default BcFee;
